import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import '../styles/Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo-section">
            <Link to="/" className="footer-logo">
              <span className="footer-dev-name">Julián Calle</span>
            </Link>
            <p className="footer-description">
              Creando experiencias digitales intuitivas y atractivas.
            </p>
          </div>
          
          <div className="footer-links-section">
            <h3>Enlaces</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">Inicio</Link>
              </li>
              <li>
                <Link to="/sobre-mi">Sobre Mí</Link>
              </li>
              <li>
                <Link to="/trayectoria">Trayectoria Profesional</Link>
              </li>
              <li>
                <Link to="/habilidades">Habilidades</Link>
              </li>
              <li>
                <Link to="/contacto">Contacto</Link>
              </li>
            </ul>
          </div>
          
          <div className="footer-social-section">
            <h3>Sígueme</h3>
            <div className="footer-social-links">
              <a href="https://github.com/july83" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a href="https://www.linkedin.com/in/juliancf/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {year} Julián Calle. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 